import { render, staticRenderFns } from "./FutureDeliveryRequests.vue?vue&type=template&id=b7cc3b9c"
import script from "./FutureDeliveryRequests.vue?vue&type=script&lang=js"
export * from "./FutureDeliveryRequests.vue?vue&type=script&lang=js"
import style0 from "./FutureDeliveryRequests.vue?vue&type=style&index=0&id=b7cc3b9c&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports